import React, { useEffect, useState } from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import PageHeading from '../../components/pageHeading/PageHeading'
import { useDispatch, useSelector } from 'react-redux';
import './marketingSubs.scss'
import { setLoader } from '../../slice/commonSlice'
import { fetchMarketingSubsPlans } from '../../services/auth.service'
import MarketingSubsPlan from './MarketingSubsPlan'
import { selectUser } from '../../slice/authSlice';
import { useNavigate } from "react-router-dom";

const MarketingSubs = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if(user?.isSubscribedForMarketing){
      navigate('/')
    }else{
      getPlans();
    }
  }, [])

  const getPlans = async () => {
    await dispatch(setLoader(true));
    try {
      const response = await fetchMarketingSubsPlans();
      await dispatch(setLoader(false));
      if (response.status) {
        setPlans(response.data?.plans);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  }




  return (
    <>
      <Header />
      <PageHeading title="Marketing Subscription" />
      <div className='main-container subscription-container'>
        <div className='container-wrap'>
          <div className='subscription-wrapper'>
            {
              plans?.length > 0 ?
                <>
                  {
                    plans?.map((plan, index) => (
                      <MarketingSubsPlan
                        key={index}
                        plan={plan}
                      />
                    ))
                  }
                </>
                : <p>No plan available</p>
            }
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default MarketingSubs